import React from "react";
import { useRouteMatch } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "../../constants";
import { SummaryCard } from "../../components/SummaryCard";
import { RoutingTabs } from "../../components/RoutingTabs";
import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";
import AudioSeries from "./AudioSeries/AudioSeries";
import AudioSoundscapes from "./AudioSoundscapes/AudioSoundscapes";
import AudioShares from "./AudioShares/AudioShares";
import AudioSingle from "./SingleAudio/AudioSingle";
import AddAudio from "./SingleAudio/AddAudio";
import UpdateAudio from "./SingleAudio/UpdateAudio";
import AudioSingleDetail from "./SingleAudio/AudioSingleDetail";
import AddSeries from "./AudioSeries/AddSeries";
import UpdateSeries from "./AudioSeries/UpdateSeries";
import AudioSeriesDetail from "./AudioSeries/AudioSeriesDetail";
import AddSoundscape from "./AudioSoundscapes/AddSoundscape";
import UpdateSoundscape from "./AudioSoundscapes/UpdateSoundscape";
import AudioSoundscapeDetail from "./AudioSoundscapes/AudioSoundscapeDetail";
import AddShare from "./AudioShares/AddShare";
import UpdateShare from "./AudioShares/UpdateShare";
import AudioShareDetail from "./AudioShares/AudioShareDetail";
import AddOnboarding from "./Onboarding/AddOnboarding";
import UpdateOnboarding from "./Onboarding/UpdateOnboarding";
import OnboardingDetail from "./Onboarding/OnboardingDetail";
import Onboarding from "./Onboarding/Onboarding";

const AudioContentManagement = () => {
    const matches = useRouteMatch();

    const CONFIG = {
        tabsConfig: [
            // Singles Tab
            {
                title: "Singles",
                id: "1",
                defaultActive: true,
                exact: true,
                path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES,
                component: <AudioSingle />,
                children: [
                    {
                        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_ADD,
                        exact: false,
                        component: <AddAudio />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_UPDATE,
                            {
                                singlesID: matches?.params?.singlesID
                            }
                        ),
                        exact: false,
                        component: <UpdateAudio />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SINGLES_DETAILS,
                            { singlesID: matches?.params?.singlesID }
                        ),
                        exact: false,
                        component: <AudioSingleDetail />
                    }
                ]
            },

            // Series Tab
            {
                title: "Series",
                id: "2",
                defaultActive: false,
                exact: true,
                path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES,
                component: <AudioSeries />,
                children: [
                    {
                        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_ADD,
                        exact: false,
                        component: <AddSeries />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_UPDATE,
                            {
                                seriesID: matches?.params?.seriesID
                            }
                        ),
                        exact: false,
                        component: <UpdateSeries />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SERIES_DETAILS,
                            {
                                seriesID: matches?.params?.seriesID
                            }
                        ),
                        exact: false,
                        component: <AudioSeriesDetail />
                    }
                ]
            },

            // Soundscapes Tab
            {
                title: "Soundscapes",
                id: "3",
                defaultActive: false,
                exact: true,
                path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES,
                component: <AudioSoundscapes />,
                children: [
                    {
                        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_ADD,
                        exact: false,
                        component: <AddSoundscape />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_UPDATE,
                            {
                                soundscapesID: matches?.params?.soundscapesID
                            }
                        ),
                        exact: false,
                        component: <UpdateSoundscape />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SOUNDSCAPES_DETAILS,
                            {
                                soundscapesID: matches?.params?.soundscapesID
                            }
                        ),
                        exact: false,
                        component: <AudioSoundscapeDetail />
                    }
                ]
            },

            // Shares tab change to stories
            {
                title: "Stories",
                id: "4",
                defaultActive: false,
                exact: true,
                path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES,
                component: <AudioShares />,
                children: [
                    {
                        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_ADD,
                        exact: false,
                        component: <AddShare />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_UPDATE,
                            {
                                sharesID: matches?.params?.sharesID
                            }
                        ),
                        exact: false,
                        component: <UpdateShare />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_SHARES_DETAILS,
                            {
                                sharesID: matches?.params?.sharesID
                            }
                        ),
                        exact: false,
                        component: <AudioShareDetail />
                    }
                ]
            },
            // Onboarding Tab
            {
                title: "Onboarding",
                id: "5",
                defaultActive: false,
                exact: true,
                path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING,
                component: <Onboarding />,
                children: [
                    {
                        path: APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_ADD,
                        exact: false,
                        component: <AddOnboarding />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_UPDATE,
                            {
                                onboardingID: matches?.params?.onboardingID
                            }
                        ),
                        exact: false,
                        component: <UpdateOnboarding />
                    },
                    {
                        path: getParamsAttachedRoute(
                            APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING_DETAILS,
                            {
                                onboardingID: matches?.params?.onboardingID
                            }
                        ),
                        exact: false,
                        component: <OnboardingDetail />
                    }
                ]
            }
        ]
    };

    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.AUDIO_MANAGEMENT}</title>
            </Helmet>
            <Container fluid>
                <SummaryCard
                    cardProps={{
                        style: { padding: "0px " } // Custom border radius
                    }}
                >
                    <RoutingTabs
                        config={CONFIG}
                        isPills
                        isTabs={true}
                        parentRoute={APP_ROUTES.AUDIO_CONTENT_MANAGEMENT}
                    />
                </SummaryCard>
            </Container>
        </div>
    );
};

export default AudioContentManagement;
